import { IState } from '../../store';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { residentialPriceSelector } from './residentialPriceSelector';
import { commercialPriceSelector } from './commercialPriceSelector';
import { IPriceSelectorOptions } from './types';

export function priceSelector(state: IState, options: IPriceSelectorOptions = {}): string | null {
  const {
    offerData: { offer },
  } = state;

  const offerType = getOfferType(offer);

  if (isCommercial(offerType)) {
    return commercialPriceSelector(state, options);
  }

  return residentialPriceSelector(state, options);
}
